import { createSelector } from '@ngrx/store';

const selectLivespace = (state: any) => {
  return state.livespace;
};

// Connection state
export const selectLivespaceConnected = createSelector(
  selectLivespace,
  (state) => state.connected
);
export const selectLivespaceConnecting = createSelector(
  selectLivespace,
  (state) => state.connecting
);
export const selectLivespaceConnectError = createSelector(
  selectLivespace,
  (state) => state.connectError
);

// Contact
export const selectLivespaceContactSuccess = createSelector(
  selectLivespace,
  (state) => state
);
export const selectLivespaceContactFailure = createSelector(
  selectLivespace,
  (state) => state.error
);

// Companies
export const selectLivespaceCompaniesSuccess = createSelector(
  selectLivespace,
  (state) => state
);
export const selectLivespaceCompaniesFailure = createSelector(
  selectLivespace,
  (state) => state.error
);

// Processes
export const selectLivespaceProcessesSuccess = createSelector(
  selectLivespace,
  (state) => state
);
export const selectLivespaceProcessesFailure = createSelector(
  selectLivespace,
  (state) => state.error
);

// New Contact
export const selectLivespaceNewContactSuccess = createSelector(
  selectLivespace,
  (state) => state
);
export const selectLivespaceNewContactFailure = createSelector(
  selectLivespace,
  (state) => state.error
);

// New Company
export const selectLivespaceNewCompanySuccess = createSelector(
  selectLivespace,
  (state) => state
);
export const selectLivespaceNewCompanyFailure = createSelector(
  selectLivespace,
  (state) => state.error
);

// Deals
export const selectLivespaceDealsSuccess = createSelector(
  selectLivespace,
  (state) => state.livespace_deals
);
export const selectLivespaceDealsFailure = createSelector(
  selectLivespace,
  (state) => state.error
);

// New Deal
export const selectLivespaceNewDealSuccess = createSelector(
  selectLivespace,
  (state) => state
);
export const selectLivespaceNewDealFailure = createSelector(
  selectLivespace,
  (state) => state.error
);

// Sources
export const selectLivespaceSourcesSuccess = createSelector(
  selectLivespace,
  (state) => state.livespace_sources
);

// Users
export const selectLivespaceUsersSuccess = createSelector(
  selectLivespace,
  (state) => state.livespace_users
);

// Products
export const selectLivespaceProductsSuccess = createSelector(
  selectLivespace,
  (state) => state.livespace_products
);

// Current User
export const selectLivespaceCurrentUserSuccess = createSelector(
  selectLivespace,
  (state) => state.livespace_current_user
);

// Loading
export const selectLivespaceLoading = createSelector(
  selectLivespace,
  (state) => state.loadingLivespace
);
